import { Box, Heading, Container, Tabs, TabList, Tab, TabPanels, TabPanel } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import Layout from "scenes/layouts";
import LogosTable from "components/table";
import { useNavigate } from "react-router-dom";
import LogosTablePagination from "components/table/table-pagination";
import { usePaginator } from "chakra-paginator";
import PartnerService from "services/partners/partner-service";

const PartnerRequestPaymentScene = (): ReactElement => {
    const navigate = useNavigate();
    const [tabIndex, setTabIndex] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [withdraws, setWithdraws] = useState<any[]>([]);
    const [totalRequestWithdraw, setTotalRequestWithdraw] = useState<number>(0);
    const {
        pagesQuantity,
        currentPage,
        setCurrentPage,
        pageSize,
        setPageSize,
        offset
    } = usePaginator({
        total: totalRequestWithdraw,
        initialState: {
            pageSize: 20,
            currentPage: 1
        }
    });

    const generateStatusByTabIndex = (tabIndex: number) => {
        let status = 0;
        switch (tabIndex) {
            case 0:
                status = 10;
                break;
            case 1:
                status = 20;
                break;
            case 2:
                status = 30;
                break;
        }
        return status;
    };

    useEffect(() => {
        setIsLoading(true);
        let status = generateStatusByTabIndex(tabIndex);
        let skipCount = ((currentPage - 1) * pageSize);

        PartnerService.GetListWithdraw(status, skipCount, pageSize).then((res: any) => {
            if (res.result) {
                setWithdraws(res.result.items);
                setTotalRequestWithdraw(res.result.totalCount);
            }
        }).finally(() => {
            setIsLoading(false);
        });
    }, [tabIndex, currentPage]);

    const handleClickRow = (requestWithdraw: any) => {
        navigate(`/partners/request/${requestWithdraw.id}`);
    };

    const handlePageChange = (nextPage: number) => {
        setCurrentPage(nextPage);
    };

    const requestWithdrawTable = () => {
        return (
            <>
                <LogosTable
                    headers={[{ label: 'Mitra' }, { label: 'Tanggal' }, { label: 'Jumlah', isNumeric: true }, { label: 'Status' }]}
                    rows={[{ propertyName: 'partnerName' }, { propertyName: 'requestDate', isDatetime: true }, { propertyName: 'amount', isNumeric: true }, { propertyName: 'statusString' }]}
                    data={withdraws}
                    onRowClick={handleClickRow}
                />
                <LogosTablePagination currentPage={currentPage} pagesQuantity={pagesQuantity} handlePageChange={handlePageChange} />
            </>
        );
    }

    return (
        <Layout>
            <Container maxWidth={"8xl"} mt={2} mb={5}>
                <Box>
                    <Heading fontSize={'3xl'} fontWeight={"extrabold"}>Request Payment</Heading>
                </Box>
                <Box mt={6}>
                    <Tabs isFitted defaultIndex={tabIndex} index={tabIndex} onChange={(index) => setTabIndex(index)}>
                        <TabList overflowX={'auto'}>
                            <Tab>Pending</Tab>
                            <Tab>Completed</Tab>
                            <Tab>Rejected</Tab>
                        </TabList>
                        {
                            isLoading &&
                            <Box>Loading...</Box>
                        }
                        {
                            !isLoading &&
                            <TabPanels>
                                <TabPanel px={0} pt={8}>{requestWithdrawTable()}</TabPanel>
                                <TabPanel px={0} pt={8}>{requestWithdrawTable()}</TabPanel>
                                <TabPanel px={0} pt={8}>{requestWithdrawTable()}</TabPanel>
                            </TabPanels>
                        }
                    </Tabs>
                </Box>
            </Container>
        </Layout>
    );
};

export default PartnerRequestPaymentScene;